export enum FileValidationStatus {
  // Step 1: Validation Phase
  VALIDATING = 'validating',
  READY_TO_UPLOAD = 'ready_to_upload',
  FAILED = 'failed',
  ACTION_REQUIRED = 'action_required',
  CANCELLED = 'cancelled',

  // Step 2: Upload Phase
  UPLOADING = 'uploading',
  UPLOADED = 'uploaded',
}

export enum VersionStatus {
  NEW_FILE = 'New File',
  NEW_VERSION = 'New Version',
}

export interface UploadFileMetadata {
  id: string
  fileName: string
  fileSize: number
  fileType: string
  validationStatus: FileValidationStatus
  versionStatus: VersionStatus
  uploadProgress: number
  errorMessage?: string
  uploadUrl?: string
  documentId?: string
}

export interface DeliverableSetOption {
  id: string
  name: string
  projectName: string
  projectId: string
}

export interface RequestUploadUrls {
  deliverable_set_id: string
  files: {
    document_type: string
    filename: string
    document_id?: string | null
  }[]
}

export interface UploadUrlDetail {
  file_index: number
  document_id: string
  version_number: number
  is_initial: boolean
  blob_name: string
  blob_url: string
}

export interface ContainerData {
  container_sas_url: string
  expires_at: string
  upload_urls: UploadUrlDetail[]
}

export interface ResponseUploadUrls {
  success: boolean
  data: ContainerData[]
}

export interface ResponseConfirmUpload {
  success: boolean
  documents: {
    documentId: string
    fileName: string
    status: string
  }[]
}
